import { compose } from 'ramda';
import { createAction } from 'redux-actions';

import logError from 'app/error/logError';
import { USER_FETCHED } from 'app/features/user/actionTypes';
import redirectToFourOFour from 'app/router/helpers/redirectToFourOFour';

const userFetched = createAction(USER_FETCHED);

function fetchUserData() {
  return (dispatch, getState, { api }) =>
    api
      .fetchUserData()
      .then(compose(dispatch, userFetched))
      .catch(compose(redirectToFourOFour, logError));
}

export { fetchUserData };
